// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IPostEngagementItem,
}                               from '../interfaces';

const getPostEngagementItems = async ({
    test,
    postId,
}: {
    test: boolean,
    postId: string,
}): Promise<Map<string, IPostEngagementItem>> => {
    const functions = getFunctions();
    const handleGetPostEngagementItems = httpsCallable<
        {
            test: boolean,
            postId: string,
        },
        Record<string, IPostEngagementItem>
    >(
        functions,
        'getPostEngagementItems',
    );
    return handleGetPostEngagementItems({
        test,
        postId,
    }).then((result) => {
        const serializedItems = result.data || {};
        return new Map<string, IPostEngagementItem>(Object.entries(serializedItems));
    }).catch((err) => {
        throw err;
    });
};

export default getPostEngagementItems;
